import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';

export default class AutocompleteSearch {
  constructor() {
    this.search = null;

    this.refs = {
      algoliaSettingsJson: '.js-algolia-settings-json',
      searchDrawer: '.js-searchDrawer',
    };

    this.dom = {
      $algoliaSettingsJson: document.querySelector(this.refs.algoliaSettingsJson),
      $searchDrawer: document.querySelector(this.refs.searchDrawer),
    };

    this.state = {
      initialized: false,
      searchActiveClass: 'active-search',
    };
  }

  init() {
    const { dom, state } = this;
    if (
      !dom.$algoliaSettingsJson
      || dom.$searchDrawer.dataset.enableAutocompleteSearch === 'false'
    ) return;

    const { APP_ID, KEY } = this.getAlgoliaSettings();
    const algoliaClient = algoliasearch(APP_ID, KEY);
    const searchClient = {
      ...algoliaClient,
      search: (requests) => this.searchProxy(requests, algoliaClient),
    };

    this.search = instantsearch({
      searchClient,
      indexName: 'shopify_products',
      onStateChange: this.stateChange.bind(this),
    });

    state.initialized = true;
  }

  searchProxy(requests, algoliaClient) {
    const hasNoQuery = requests.every(({ params }) => !params.query);

    if (hasNoQuery) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
          hitsPerPage: 0,
          exhaustiveNbHits: false,
          query: '',
          params: '',
        })),
      });
    }

    return algoliaClient.search(requests);
  }

  getAlgoliaSettings() {
    const { dom } = this;
    return JSON.parse(dom.$algoliaSettingsJson.innerHTML);
  }

  stateChange({ uiState, setUiState }) {
    const { dom, state } = this;
    const { query } = uiState.shopify_products;

    if (query) {
      dom.$searchDrawer.classList.add(state.searchActiveClass);
    } else {
      dom.$searchDrawer.classList.remove(state.searchActiveClass);
    }

    setUiState(uiState);
  }

  start() {
    const { state: { initialized } } = this;
    if (!initialized) return;

    this.search.start();
  }
}
